module.exports = __webpack_public_path__ + "static/media/weight.e168395b.svg";